import React from 'react'

import Button from 'components.v2/Button'
import Modal from 'components.v2/Modal'
import RationalImage from 'components.v2/RationalImage'
import Text from 'components.v2/Text'
import withSocialButtonContainer from 'common/auth/Shared/SocialButtonContainer'

import { HostAvatar, VenueHeader, VenueContent, CloseButton } from './styled'

import asset from 'utils/asset'

const SocialButton = withSocialButtonContainer(Button)

export const SocialLogin = () => {
  return (
    <div className="flex mb-30 -mx-7pt5">
      <div className="w-1/2 px-7pt5">
        <SocialButton className="w-full" provider="facebook" large largeText>
          Facebook
        </SocialButton>
      </div>
      <div className="w-1/2 px-7pt5">
        <SocialButton className="w-full" provider="google" large largeText>
          Google
        </SocialButton>
      </div>
    </div>
  )
}

export default ({
  description,
  handleEmailLoginClick,
  isOpen,
  leaderCustomerImage,
  name,
  onRequestClose,
  vendorCoverImage,
  vendorName,
}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} noCloseButton>
      <div className="relative">
        <CloseButton onClick={onRequestClose} />
        <VenueHeader>
          <RationalImage
            src={vendorCoverImage}
            alt={vendorName}
            ratio={[400, 160]}
          />
          <HostAvatar
            className="block"
            style={{
              backgroundImage: `url("${leaderCustomerImage ||
                asset('images/avatar.png')}")`,
            }}
          />
        </VenueHeader>
        <VenueContent>
          <Text className="mb-10" variant="h3" align="center">
            Join {name}
          </Text>
          <Text
            className="mb-30"
            variant="secondary"
            color="gray3"
            align="center"
          >
            {description}
          </Text>
          <SocialLogin />
          <Text
            className="block"
            variant="secondary"
            color="primary"
            as="span"
            align="center"
            onClick={handleEmailLoginClick}
          >
            Or continue with your email address
          </Text>
        </VenueContent>
      </div>
    </Modal>
  )
}
